export const DEFAULT_MDY_FORMAT = 'MMMM d, yyyy';
export const DEFAULT_NO_YEAR_MDY_FORMAT = 'MMMM d';
export const NUMERICAL_MDY_FORMAT = 'MM/dd/yyyy';
export const NUMERICAL_NO_YEAR_MDY_FORMAT = 'MM/dd';

export const DEFAULT_DMY_FORMAT = 'd MMMM, yyyy';
export const DEFAULT_NO_YEAR_DMY_FORMAT = 'd MMMM';
export const NUMERICAL_DMY_FORMAT = 'dd/MM/yyyy';
export const NUMERICAL_NO_YEAR_DMY_FORMAT = 'dd/MM';

export const DEFAULT_YMD_FORMAT = 'yyyy MMMM dd';
export const DEFAULT_NO_YEAR_YMD_FORMAT = 'MMMM dd';
export const NUMERICAL_YMD_FORMAT = 'yyyy/MM/dd';
export const NUMERICAL_NO_YEAR_YMD_FORMAT = 'MM/dd';
